import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

// Mirrors the shared Hero ShadedBackground, but darkens the bottom on mobile
// (where the TDC copy sits) instead of the top.
export const ShadedBackground = createComponent('div', {
  className: cx(
    'col-span-full row-span-full h-full w-full',
    '[background-image:linear-gradient(189deg,rgba(0,0,0,0.00)_24.2%,rgba(0,0,0,0.60)_104.81%)]',
    'md:[background-image:linear-gradient(287deg,rgba(0,0,0,0.00)_36.99%,rgba(0,0,0,0.34)_67.35%,rgba(0,0,0,0.60)_101.97%)]',
    'lg:[background-image:linear-gradient(271deg,rgba(0,0,0,0.00)_35.46%,rgba(0,0,0,0.60)_119.23%)]'
  )
});
